import { Component, Input, NgZone, ElementRef } from '@angular/core';
import {Http, Headers, Response} from '@angular/http';
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/map'
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { httpService } from '../service/servicio'
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ViewContainerRef } from '@angular/core';


@Component({
  selector: 'app-tarifas',
  templateUrl: './tarifas.component.html',
  styleUrls: ['./tarifas.component.css']
})
export class TarifasComponent {


    constructor (private http: httpService,  public toastr: ToastsManager, vcr: ViewContainerRef, private elem: ElementRef) {

        this.toastr.setRootViewContainerRef(vcr);
         ("en Tarifas-..");
        this.descargarMaquinas();
        this.descargarTarifas();
        this.descargarArticulos();
        this.orden(2);

      };


      uploaded = {
        Status:0,
        Text:''

      }

      @Input() tarifas: any = [];
      @Input() articulos: any = [];

      tituloTarifa:string =  '';
      tarifaSearch: string ='';
      place:string = 'Buscar por Articulo';
      sort: string = 'Articulo';
      mostrarDatosTarifa:boolean = false;

      home() {


          this.mostrarDatosTarifa = false;
          this.http.sw.mostrarTarifas = false;
          this.http.sw.mostrarDatosmaquinas = false;
          this.http.sw.mostrarMaquinas = true;
          this.http.sw.mostrarMenu = true;

      }

      orden(n) {
        if (n == 1) { this.sort='Id'; this.place='Buscar por Id' };
        if (n == 2) { this.sort='Articulo'; this.place='Buscar por Articulo' };
        if (n == 3) { this.sort='Precio'; this.place='Buscar por Precio' };
      }

     quitarfiltro(tipo: Number) {
        this.tarifaSearch = '';
     }

    filtro() {

        return this.tarifas.filter((tarifa) => {
          if (this.sort == 'Id')
             return tarifa.Id.toLowerCase().indexOf(this.tarifaSearch.toLowerCase()) != -1;
          if (this.sort == 'Articulo')
             return tarifa.Articulo.toLowerCase().indexOf(this.tarifaSearch.toLowerCase()) != -1;
          if (this.sort == 'Precio')
             return tarifa.Precio.toLowerCase().indexOf(this.tarifaSearch.toLowerCase()) != -1;

         });
    }

    copiar() {

       this.http.descargarTarifas(this.http.maquinaGrabar.Id)
       .subscribe(tarifas => {
                  this.http.tarifacopiar = tarifas;
                   (this.http.tarifacopiar);
                  alert("Tarifa Copiada");
             }, err => {

                    (err.message);
             }, () => {
                  ('completed');
             });


    }

    descargarMaquinas() {
      this.http.descargarMaquinas(this.http.maquinaGrabar.Id)
          .subscribe(maquina => {

                     this.tituloTarifa = maquina.Id + " - " + maquina.Descmarca + " " + maquina.Descmodelo + " ( " +  maquina.Desccliente + " - " + maquina.DescPosicion + " )";
                      (this.tituloTarifa);
                }, err => {

                       (err.message);
                }, () => {
                     ('completed');
                });
    }


    descargarTarifas() {

            this.http.descargarTarifas(this.http.maquinaGrabar.Id)
                    .subscribe(tarifa => {
                         this.tarifas = tarifa;

                    }, err => {

                    }, () => {
                      if (this.tarifas == null) {

                          this.toastr.warning("No existen tarifas", "Tarifas");

                      }


             });
          }


    descargarArticulos() {

                  this.http.descargarArticulos()
                          .subscribe(articulo => {
                               this.articulos = articulo;

                          }, err => {

                          }, () => {
                            if (this.http.tarifaGrabar.Id == 0 ) {
                              this.http.tarifaGrabar.Articulo = this.articulos[0].Id;

                            }

                   });
    }

    pulsado(tarifa) {
        this.http.tarifaGrabar = this.http.nuevaTarifa();
        this.http.tarifaGrabar.Id = tarifa.Id;
        this.http.tarifaGrabar.Maquina = tarifa.IdMaquina;
        this.http.tarifaGrabar.Articulo = tarifa.IdArticulo;
        this.http.tarifaGrabar.Precio = tarifa.Precio;

        this.mostrarDatosTarifa = true;
    }

    crearTarifa() {

       this.http.tarifaGrabar = this.http.nuevaTarifa();
       this.descargarArticulos();
       this.mostrarDatosTarifa = true;
    }

    selArticulo(Id) {

        this.http.tarifaGrabar.Articulo = Id;
    }

    volver() {

      this.http.sw.mostrarDatosmaquinas = true;
      this.toastr.warning("Cargando Datos...", "Internet");

    }

    cancelar() {
        this.http.descargarTarifas(this.http.maquinaGrabar.Id).subscribe(respuesta => {
        this.tarifas = respuesta;
        this.mostrarDatosTarifa = false;
      });

    }

    borrarpulsado(tarifa) {
       ("Borrar pulsado");
      this.http.tarifaGrabar = tarifa;
    }

    borrar(){

        this.http.datosPost.action = 2; // borrar
        this.http.datosPost.datos = this.http.tarifaGrabar;
        this.http.tarifa(this.http.datosPost).subscribe(respuesta => {
              this.http.uploaded = respuesta;

          }, err => {
               (err.message);
          }, () => {
              if (this.http.uploaded.Status == 1) {
                    this.toastr.success(this.http.uploaded.Text,'Tarifas');
                    this.http.descargarTarifas(this.http.maquinaGrabar.Id).subscribe(respuesta => {
                      this.tarifas =respuesta;
                  });
              }else{

                  this.toastr.error(this.http.uploaded.Text,'Tarifas');
              }
        });

    }


    grabar() {
      this.http.tarifaGrabar.Maquina = this.http.maquinaGrabar.Id;
      this.http.datosPost.action = 1; // por defecto Update
      if (this.http.tarifaGrabar.Id == 0) this.http.datosPost.action = 0; // si es nueva Insert;
        this.http.datosPost.datos = this.http.tarifaGrabar;
        this.http.tarifa(this.http.datosPost).subscribe(respuesta => {
            this.http.uploaded = respuesta;

          }, err => {

          }, () => {
            if (this.http.uploaded.Status == 1) {
                this.toastr.success(this.http.uploaded.Text,'Tarifa');
                this.http.descargarTarifas(this.http.maquinaGrabar.Id).subscribe(respuesta => {
                  this.tarifas = respuesta;
                  this.mostrarDatosTarifa = false;
                });
            }else{
                this.toastr.error(this.http.uploaded.Text,'Tarifa');
            }
      });

    }


  pegar() {
            this.http.datosPost.action = 4; // duplicar
            this.http.datosPost.datos = this.http.tarifacopiar;
            console.log(this.http.maquinaGrabar.Id)
             // esta tarifa
            this.http.datosPost.Id = this.http.maquinaGrabar.Id   // con este Id de máquina

            this.http.tarifa(this.http.datosPost).subscribe(respuesta => {
                this.http.uploaded = respuesta;

              }, err => {

              }, () => {
                if (this.http.uploaded.Status == 1) {
                    this.toastr.success(this.http.uploaded.Text,'Tarifa');
                    this.http.descargarTarifas(this.http.maquinaGrabar.Id).subscribe(respuesta => {
                      this.tarifas = respuesta;
                      this.mostrarDatosTarifa = false;
                    });
                }else{
                    this.toastr.error(this.http.uploaded.Text,'Tarifa');
                }
          });

  }


}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/duran/duran-web/src/app/tarifas/tarifas.component.ts